export default __webpack_public_path__ + "static/media/facebook.9ddfa2eb.svg";